import { render, staticRenderFns } from "./UserAdminComponent.vue?vue&type=template&id=a5a84b8c&scoped=true"
import script from "./UserAdminComponent.vue?vue&type=script&lang=js"
export * from "./UserAdminComponent.vue?vue&type=script&lang=js"
import style0 from "./UserAdminComponent.vue?vue&type=style&index=0&id=a5a84b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a84b8c",
  null
  
)

export default component.exports